<template>
  <div class="invitations-wrapper">

    <v-toolbar
      dense
      tabs
      color="primary darken-2"
      dark
      class="page_title"
    >
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <a href="javascript: history.go(-1)" class="pa-0">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-arrow-left headline"></i>
              </v-btn>
            </a>
          My Invitations
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
           <router-link :to="'/njangi'" class="pa-0 text-xs-right">
              <v-btn flat fab small class="pa-0">
                <i class="fas fa-close headline"></i>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
          </v-toolbar>

    <div class="mobile-header">
      <v-app-bar color="#00479b" dark flat>
        <v-btn icon @click="loadInvitations">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-app-bar>
    </div>

    <!-- Main Content -->
    <div class="content-container">
      <!-- Loading State -->
      <div v-if="loading" class="loading-state pa-4 text-center">
        <v-progress-circular
          indeterminate
          color="#00479b"
          size="40"
          width="3"
        ></v-progress-circular>
        <p class="mt-3 mb-0" style="color: #666;">Loading invitations...</p>
      </div>

      <!-- Empty State -->
      <div v-else-if="invitations.length === 0" class="empty-state pa-4">
        <div class="text-center pa-6">
          <v-icon size="80" color="#e0e0e0" class="mb-3">mdi-email-outline</v-icon>
          <h3 class="mb-2" style="color: #333;">No Pending Invitations</h3>
          <p class="mb-4" style="color: #666;">
            You haven't received any invitations to join Njangi groups yet.
          </p>
          <v-btn
            color="#00479b"
            dark
            @click="loadInvitations"
            class="refresh-btn"
            elevation="0"
          >
            <v-icon left>mdi-refresh</v-icon>
            Refresh
          </v-btn>
        </div>
      </div>

      <!-- Invitations List -->
      <div v-else class="invitations-list pa-3">
        <div class="section-title pa-3">
          <div class="d-flex justify-space-between align-center">
            <h3 class="mb-0">
              <v-icon left color="#00479b">mdi-email</v-icon>
              My Invitations
            </h3>
            <v-chip color="#e3f2fd" text-color="#00479b" small>
              {{ invitations.length }} pending
            </v-chip>
          </div>
        </div>

        <div class="invitations-grid">
          <div
            v-for="invitation in invitations"
            :key="invitation.id"
            class="invitation-card"
          >
            <!-- Card Header -->
            <div class="card-header" style="background: linear-gradient(135deg, #00479b 0%, #2c6bb5 100%);">
              <div class="d-flex align-center">
                <div class="header-icon mr-3">
                  <v-icon color="white" size="28">mdi-account-group</v-icon>
                </div>
                <div class="flex-grow-1">
                  <h4 class="white--text mb-1">{{ invitation.group_name || 'Unknown Group' }}</h4>
                  <div class="invitation-time caption white--text" style="opacity: 0.8;">
                    Received {{ formatTimeAgo(invitation.created_at) }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Card Content -->
            <div class="card-content pa-3">
              <!-- Admin Info -->
              <div class="info-item mb-3">
                <div class="info-label">
                  <v-icon small color="#666" class="mr-2">mdi-account</v-icon>
                  <span>Group Admin</span>
                </div>
                <div class="info-value">
                  {{ invitation.admin_username || invitation.admin_name || 'Unknown' }}
                </div>
              </div>

              <!-- Contribution Amount -->
              <div class="info-item mb-3" v-if="invitation.contribution_amount">
                <div class="info-label">
                  <v-icon small color="#666" class="mr-2">mdi-cash</v-icon>
                  <span>Contribution</span>
                </div>
                <div class="info-value">
                  {{ formatCurrency(invitation.contribution_amount) }}
                </div>
              </div>

              <!-- Collection Cycle -->
              <div class="info-item mb-3" v-if="invitation.collecting_cycle">
                <div class="info-label">
                  <v-icon small color="#666" class="mr-2">mdi-calendar-clock</v-icon>
                  <span>Cycle</span>
                </div>
                <div class="info-value">
                  {{ formatCycle(invitation.collecting_cycle) }}
                </div>
              </div>

              <!-- Description -->
              <div class="info-item mb-3" v-if="invitation.group_description">
                <div class="info-label">
                  <v-icon small color="#666" class="mr-2">mdi-information</v-icon>
                  <span>Description</span>
                </div>
                <div class="info-value description-text">
                  {{ truncateText(invitation.group_description, 80) }}
                </div>
              </div>

              <!-- Expired Badge -->
              <div v-if="isInvitationExpired(invitation)" class="expired-badge mt-3">
                <div class="warning-card pa-3" style="background-color: #fff8e1; border-radius: 8px;">
                  <div class="d-flex align-center">
                    <v-icon color="#ff9800" small class="mr-2">mdi-alert</v-icon>
                    <span style="color: #333; font-size: 0.875rem;">This invitation has expired</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card Actions -->
            <div class="card-actions pa-3">
              <div class="d-flex gap-2">
                <v-btn
                  text
                  color="#ff5252"
                  @click="showRejectDialog(invitation)"
                  :disabled="isInvitationExpired(invitation)"
                  block
                  class="reject-btn"
                >
                  <v-icon left small>mdi-close</v-icon>
                  Reject
                </v-btn>
                <v-btn
                  color="#00479b"
                  dark
                  @click="showAcceptDialog(invitation)"
                  :disabled="isInvitationExpired(invitation)"
                  block
                  class="accept-btn"
                  elevation="0"
                >
                  <v-icon left small>mdi-check</v-icon>
                  Accept
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Accept Invitation Dialog -->
    <v-dialog v-model="acceptDialog.show" max-width="800px" persistent>
      <div class="dialog-wrapper" v-if="acceptDialog.invitation">
        <!-- Dialog Header -->
        <div class="dialog-header" style="background: linear-gradient(135deg, #00479b 0%, #2c6bb5 100%);">
          <div class="d-flex align-center">
            <v-btn icon @click="closeAcceptDialog" dark class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <h3 class="white--text mb-0">
              <v-icon left color="white">mdi-check-circle</v-icon>
              Accept Invitation
            </h3>
          </div>
        </div>

        <!-- Dialog Content -->
        <div class="dialog-content">
          <!-- Group Info -->
          <div class="group-info-card pa-4 mb-4">
            <div class="d-flex align-center mb-3">
              <v-avatar color="#e3f2fd" size="50" class="mr-3">
                <v-icon color="#00479b" size="30">mdi-account-group</v-icon>
              </v-avatar>
              <div>
                <h4 class="mb-1" style="color: #333;">{{ acceptDialog.invitation.group_name }}</h4>
                <p class="mb-0" style="color: #666; font-size: 0.875rem;">
                  Invitation from {{ acceptDialog.invitation.admin_username }}
                </p>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="info-grid">
              <div class="info-item">
                <div class="info-label">Contribution</div>
                <div class="info-value" style="color: #00479b; font-weight: 500;">
                  {{ formatCurrency(acceptDialog.invitation.contribution_amount) }}
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">Cycle</div>
                <div class="info-value" style="color: #00479b; font-weight: 500;">
                  {{ formatCycle(acceptDialog.invitation.collecting_cycle) }}
                </div>
              </div>
              <div class="info-item">
                <div class="info-label">Invited On</div>
                <div class="info-value" style="color: #666;">
                  {{ formatDate(acceptDialog.invitation.created_at) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Warning Section -->
          <div class="warning-section pa-4 mb-4" style="background-color: #fff8e1; border-radius: 12px;">
            <div class="d-flex align-start">
              <v-icon color="#ff9800" class="mr-3 mt-1">mdi-alert-circle</v-icon>
              <div>
                <h4 class="mb-2" style="color: #ff9800;">Important Disclaimer</h4>
                <p style="color: #333; font-size: 0.875rem; line-height: 1.5;">
                  By accepting this invitation, you acknowledge that PettyCash SAS acts only as a platform provider
                  and assumes NO responsibility for member behavior, financial disputes, or any losses incurred.
                </p>
              </div>
            </div>
          </div>

          <!-- Group Rules -->
          <div class="rules-section pa-4 mb-4">
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="expansion-header">
                  <span class="font-weight-medium">Group Rules & Conditions</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-3">
                  <div v-if="acceptDialog.invitation.group_rules" style="color: #666; font-size: 0.875rem;">
                    {{ acceptDialog.invitation.group_rules }}
                  </div>
                  <div v-else class="text-center py-3" style="color: #999;">
                    No specific rules defined for this group.
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header class="expansion-header">
                  <span class="font-weight-medium">Member Responsibilities</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pt-3">
                  <ul style="color: #666; font-size: 0.875rem; padding-left: 20px;">
                    <li class="mb-2">Make contributions on time as per schedule</li>
                    <li class="mb-2">Respect all group rules and decisions</li>
                    <li class="mb-2">Maintain respectful communication with members</li>
                    <li class="mb-2">Report issues promptly to group admin</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Terms Acceptance -->
          <div class="terms-section pa-4 mb-4" style="background-color: #f8f9fa; border-radius: 12px;">
            <v-checkbox
              v-model="acceptDialog.termsAccepted"
              hide-details
              class="mt-0"
            >
              <template v-slot:label>
                <div style="color: #333; font-size: 0.875rem; line-height: 1.5;">
                  <strong>I understand and accept</strong> that the group admin is responsible for management,
                  funds are held in PettyCash accounts, and I must resolve disputes directly with the admin.
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>

        <!-- Dialog Actions -->
        <div class="dialog-actions pa-4">
          <v-btn
            text
            @click="closeAcceptDialog"
            :disabled="acceptDialog.loading"
            class="cancel-btn"
            block
            large
          >
            Cancel
          </v-btn>
          <v-btn
            color="#00479b"
            dark
            @click="acceptInvitation"
            :loading="acceptDialog.loading"
            :disabled="!acceptDialog.termsAccepted"
            block
            large
            class="join-btn"
            elevation="0"
          >
            <v-icon left>mdi-check</v-icon>
            Accept & Join Group
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <!-- Reject Invitation Dialog -->
    <v-dialog v-model="rejectDialog.show" max-width="400px" persistent>
      <div class="dialog-wrapper">
        <!-- Dialog Header -->
        <div class="dialog-header" style="background: linear-gradient(135deg, #d32f2f 0%, #ef5350 100%);">
          <h3 class="white--text mb-0">
            <v-icon left color="white">mdi-alert</v-icon>
            Reject Invitation
          </h3>
        </div>

        <!-- Dialog Content -->
        <div class="dialog-content pa-4 text-center">
          <v-icon color="#d32f2f" size="60" class="mb-3">mdi-cancel</v-icon>
          <h4 class="mb-2" style="color: #333;">
            Reject invitation from {{ rejectDialog.invitation?.group_name }}?
          </h4>
          <p class="mb-0" style="color: #666; font-size: 0.875rem;">
            This action cannot be undone. You will need a new invitation to join this group.
          </p>
        </div>

        <!-- Dialog Actions -->
        <div class="dialog-actions pa-4">
          <v-btn
            text
            @click="rejectDialog.show = false"
            :disabled="rejectDialog.loading"
            block
            large
            class="cancel-btn"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#d32f2f"
            dark
            @click="rejectInvitation"
            :loading="rejectDialog.loading"
            block
            large
            class="reject-confirm-btn"
            elevation="0"
          >
            <v-icon left>mdi-delete</v-icon>
            Confirm Rejection
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  name: 'NjangiInvitations',

  data() {
    return {
      loading: false,
      invitations: [],

      acceptDialog: {
        show: false,
        invitation: null,
        termsAccepted: false,
        loading: false
      },

      rejectDialog: {
        show: false,
        invitation: null,
        loading: false
      }
    };
  },

  mounted() {
    this.loadInvitations();
  },

  methods: {
    async loadInvitations() {
      this.loading = true;
      try {
        const response = await axios.get('/api/v1/njangi/invitations/');

        if (Array.isArray(response.data)) {
          this.invitations = response.data;
        } else if (response.data && typeof response.data === 'object') {
          if (response.data.results) {
            this.invitations = response.data.results;
          } else if (response.data.invitations) {
            this.invitations = response.data.invitations;
          } else {
            this.invitations = Object.values(response.data);
          }
        } else {
          this.invitations = [];
        }
      } catch (error) {
        console.error('Load invitations error:', error);
        this.showSnackbar('Failed to load invitations', 'error');
      } finally {
        this.loading = false;
      }
    },

    showAcceptDialog(invitation) {
      this.acceptDialog = {
        show: true,
        invitation: invitation,
        termsAccepted: false,
        loading: false
      };
    },

    closeAcceptDialog() {
      this.acceptDialog = {
        show: false,
        invitation: null,
        termsAccepted: false,
        loading: false
      };
    },

    showRejectDialog(invitation) {
      this.rejectDialog = {
        show: true,
        invitation: invitation,
        loading: false
      };
    },

    async acceptInvitation() {
      if (!this.acceptDialog.invitation) return;

      this.acceptDialog.loading = true;
      try {
        const payload = {
          invitation_id: this.acceptDialog.invitation.id
        };

        if (this.acceptDialog.invitation.group_code) {
          payload.invite_key = this.acceptDialog.invitation.group_code;
        }

        const response = await axios.post('/api/v1/njangi/groups/accept-invitation/', payload);

        this.showSnackbar('Successfully joined the group!', 'success');

        this.invitations = this.invitations.filter(
          inv => inv.id !== this.acceptDialog.invitation.id
        );

        this.closeAcceptDialog();

        setTimeout(() => {
          if (response.data.group_id) {
            this.$router.push(`/njangi/groups/detail/${response.data.group_id}`);
          } else {
            this.$router.push('/njangi/my-groups');
          }
        }, 1500);

      } catch (error) {
        let errorMessage = 'Failed to accept invitation';
        if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.showSnackbar(errorMessage, 'error');
      } finally {
        this.acceptDialog.loading = false;
      }
    },

    async rejectInvitation() {
      if (!this.rejectDialog.invitation) return;

      this.rejectDialog.loading = true;
      try {
        await axios.post('/api/v1/njangi/groups/reject-invitation/', {
          invitation_id: this.rejectDialog.invitation.id
        });

        this.showSnackbar('Invitation rejected', 'success');

        this.invitations = this.invitations.filter(
          inv => inv.id !== this.rejectDialog.invitation.id
        );

        this.rejectDialog.show = false;

      } catch (error) {
        let errorMessage = 'Failed to reject invitation';
        if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        }

        this.showSnackbar(errorMessage, 'error');
      } finally {
        this.rejectDialog.loading = false;
      }
    },

    formatCurrency(amount) {
      if (!amount && amount !== 0) return 'N/A';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'XAF',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    },

    formatDate(dateString) {
      if (!dateString) return 'Unknown';
      return dayjs(dateString).format('DD MMM YYYY, HH:mm');
    },

    formatTimeAgo(dateString) {
      if (!dateString) return 'recently';
      return dayjs(dateString).fromNow();
    },

    formatCycle(cycle) {
      if (!cycle) return 'Not specified';

      const cycleMap = {
        'daily': 'Daily',
        'weekly': 'Weekly',
        'monthly': 'Monthly',
        'Daily': 'Daily',
        'Weekly': 'Weekly',
        'Monthly': 'Monthly'
      };

      return cycleMap[cycle] || cycle;
    },

    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    isInvitationExpired(invitation) {
      if (!invitation?.expires_at) return false;
      const now = new Date();
      const expiresAt = new Date(invitation.expires_at);
      return now > expiresAt;
    },

    showSnackbar(message, type = 'info') {
      try {
        this.$store.dispatch('snackbar/showMessage', {
          text: message,
          color: type === 'success' ? '#00479b' : '#d32f2f'
        });
      } catch (e) {
        if (this.$root.$emit) {
          this.$root.$emit('show-snackbar', {
            message: message,
            type: type
          });
        }
        console.log(`${type.toUpperCase()}: ${message}`);
      }
    }
  }
};
</script>

<style scoped>
.invitations-wrapper {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
  min-height: 100vh;
}

.mobile-header {
  position: sticky;
  top: 0;
  z-index: 100;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.refresh-btn {
  border-radius: 10px;
  text-transform: none;
  letter-spacing: normal;
}

.section-title {
  padding: 16px;
  background: white;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 71, 155, 0.1);
}

.invitations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

@media (max-width: 600px) {
  .invitations-grid {
    grid-template-columns: 1fr;
  }
}

.invitation-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 71, 155, 0.1);
  transition: all 0.3s ease;
}

.invitation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 71, 155, 0.15);
}

.card-header {
  padding: 20px;
  color: white;
}

.header-icon {
  padding: 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
}

.invitation-time {
  font-size: 0.75rem;
}

.card-content {
  padding: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 0.875rem;
  flex: 1;
}

.info-value {
  font-weight: 500;
  color: #333;
  text-align: right;
  flex: 1;
  margin-left: 8px;
}

.description-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: #666;
}

.card-actions {
  background-color: #f8f9fa;
  border-top: 1px solid #e0e0e0;
}

.gap-2 {
  gap: 8px;
}

.reject-btn,
.accept-btn {
  border-radius: 8px;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
  height: 40px;
}

/* Dialog Styles */
.dialog-wrapper {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  padding: 20px;
  color: white;
}

.dialog-content {
  flex: 1;
  overflow-y: auto;
  background: #f8f9fa;
}

.group-info-card {
  background: white;
  border-radius: 12px;
  margin: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.info-grid .info-item {
  border: none;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
}

.info-grid .info-label {
  color: #666;
  font-size: 0.75rem;
  margin-bottom: 4px;
}

.expansion-header {
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 4px;
}

.expansion-header >>> .v-expansion-panel-header__icon {
  color: #00479b;
}

.terms-section {
  margin: 16px;
}

.dialog-actions {
  background: white;
  border-top: 1px solid #e0e0e0;
  padding: 20px;
}

.cancel-btn {
  border-radius: 10px;
  color: #666;
  text-transform: none;
  letter-spacing: normal;
  margin-bottom: 8px;
}

.join-btn,
.reject-confirm-btn {
  border-radius: 10px;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 500;
}

/* Custom Scrollbar */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>